let graphicLayer;
export default {
  // inject:['marsMap','marsMeasure'],
  props: ["diggingHeight"],
  data() {
    return {
      terrainDigging_show: true,
      diggingHeightNumber: 50,
      isFold: false,
    };
  },
  methods: {
    adjustDiggingHeight() {
      // alert("触发！");
      //this.$emit('changeHeightInterval', this.heightIntervalNumber);
      this.$GLOBAL.terrainClip.diffHeight = this.diggingHeightNumber;
      console.log(this.diggingHeightNumber);
    },
    terrainDiggingBox_close() {
      // this.transparency_show = false;
      this.removeAll();
      this.$emit("terrainDiggingBox_close");
    },
    addRectangle() {
      //alert(terrainClip.diffHeight);
      graphicLayer.startDraw({
        type: "rectangle",
        style: {
          color: "#007be6",
          opacity: 0.8,
        },
        success: (graphic) => {
          //绘制成功后回调
          let positions = graphic.getOutlinePositions(false);
          graphicLayer.clear();

          console.log(
            JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))
          ); //打印下边界

          //挖地区域
          console.log(positions);
          this.$GLOBAL.terrainClip.addArea(positions);
        },
      });
    },
    addPolygon() {
      graphicLayer.startDraw({
        type: "polygon",
        style: {
          color: "#007be6",
          opacity: 0.5,
          outline: false,
        },
        success: (graphic) => {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          graphicLayer.clear();

          console.log(
            JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))
          ); //打印下边界

          this.$GLOBAL.terrainClip.addArea(positions);
        },
      });
    },
    removeAll() {
      this.$GLOBAL.terrainClip.clear(); //清除挖地区域
      graphicLayer.clear();
    },
  },
  mounted() {
    if (this.diggingHeight) {
      this.diggingHeightNumber = this.diggingHeight;
    }
    //不存在已创建的该对象才创建，避免一些特殊情况下重复给map添加图层，导致异常或者卡顿。
    if (!graphicLayer) {
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
    }

    if (!this.$GLOBAL.terrainClip) {
      this.$GLOBAL.terrainClip = new mars3d.thing.TerrainClip({
        diffHeight: this.diggingHeightNumber, //井的深度
        image: "/img/textures/excavate_side_min.png",
        imageBottom: "/img/textures/excavate_bottom_min.jpg",
        splitNum: 80, //井边界插值数
      });
      this.$GLOBAL.map.addThing(this.$GLOBAL.terrainClip);
    }
  },
  destroyed() {
    graphicLayer.clear();
    this.$GLOBAL.map.removeLayer(graphicLayer, true);
    this.$GLOBAL.map.removeThing(this.$GLOBAL.terrainClip, true);
    graphicLayer = null;
    this.$GLOBAL.terrainClip = null;
  },
};
